import { useMemo } from 'react';
import { QueryParams } from 'shared/types';
import useFetchByParams from './useFetchByParams';
import { Year } from 'shared/models';
import { fetchYears, selectYears } from 'app/store/slices/year.slice';

export const useYearQuery = (
  query?: QueryParams) => {
  return useMemo(() => {
    const queryParams = { ...query };

    return [queryParams];
  }, []);
};

export const useYears = (query: any) => {
   return useFetchByParams<Year[]>({
    action: fetchYears,
    dataSelector: selectYears,
    params: query,
  });
};
